import { DownloadIcon } from "@heroicons/react/solid";
import { QRCodeCanvas } from "qrcode.react";
import { useMemo } from "react";
import toast from "react-hot-toast";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";

interface Props {
  open: boolean;
  onClose: () => void;
  url: string;
}

const QRCodeModal = ({ open, onClose, url }: Props) => {
  const downloadQRCode = () => {
    try {
      const canvas = document.getElementById("qr-gen") as HTMLCanvasElement;
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "qrcode.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error: any) {
      toast.error(error.messaage || error);
    }
  };

  const screenSize =
    (typeof screen !== "undefined" && screen?.width) ?? 0 > 640 ? 600 : 280;

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        actions={
          <Button theme="white" onClick={downloadQRCode}>
            <DownloadIcon height="18rem" width="18rem" className="mr-1" />
            Download
          </Button>
        }
        showCloseButton
      >
        <div className="bg-white rounded overflow-hidden">
          <QRCodeCanvas
            id="qr-gen"
            className="m-[-24rem]"
            value={url}
            size={screenSize}
            includeMargin
          />
        </div>
      </Modal>
    </>
  );
};

export default QRCodeModal;
